import { cloneElement, type ReactElement, type ReactNode } from "react";
import * as Dialog from "@radix-ui/react-dialog";

// A dialog or full-screen shell. Radix portals it to document.body so a
// transformed ancestor cannot trap `fixed`. Focus and scroll stay with the
// page: the shell already covers the viewport, and stealing focus would move
// the cursor out of whatever the user was editing.
export function Modal({
  children,
}: {
  children: ReactElement<{ children?: ReactNode }>;
}) {
  return (
    <Dialog.Root open modal={false}>
      <Dialog.Portal>
        <Dialog.Content
          asChild
          aria-describedby={undefined}
          onOpenAutoFocus={(event) => event.preventDefault()}
          onCloseAutoFocus={(event) => event.preventDefault()}
          onEscapeKeyDown={(event) => event.preventDefault()}
          onPointerDownOutside={(event) => event.preventDefault()}
          onInteractOutside={(event) => event.preventDefault()}
        >
          {cloneElement(
            children,
            undefined,
            <Dialog.Title className="sr-only">Dialog</Dialog.Title>,
            children.props.children,
          )}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
